// Audition Form components
export {
  AuditionForm,
  RecordSettingsShell,
  SettingsSidebar,
  BasicInfoTab,
  RequirementsTab,
  DatesTab,
  ContractTab,
  ApplicationSettingsTab,
} from './audition-form';

// Record Shell (type-aware sub-navigation for the record workspace)
export { RecordShell } from './record-shell/record-shell';

// Applications List

// Audition Offers
export { AuditionOffersList, GenerateOffersForm } from './audition-offers';

// Application Chat

// Apply Button

// Application Form Builder
export {
  ApplicationFormBuilder,
  DynamicFormRenderer,
  FormBuilderPanel,
  StepperFormRenderer,
  type StepperStepInfo,
  FieldConfigEditor,
  TemplateSelector,
} from './application-form';
